var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import html from "./modal.html";
import "./modal.scss";
import Component from "../lib/component";
var HideEventName = "hidden.bs.modal";
var defaultModalOptions = {
    title: "提示",
    isConfirmModal: false,
    backdrop: true,
    showHeader: true,
    showFooter: true,
    isActionSheet: false
};
var MyComponent = /** @class */ (function (_super) {
    __extends(MyComponent, _super);
    function MyComponent() {
        var _this = _super.call(this, "modal", html, { singleInstance: true }) || this;
        _this.message = ko.observable("");
        _this.options = {
            componentName: "modal",
            title: ko.observable("提示"),
            isConfirmModal: ko.observable(false),
            backdrop: ko.observable(true),
            showHeader: ko.observable(true),
            showFooter: ko.observable(true),
            isActionSheet: ko.observable(false)
        };
        _this.modalResult = false;
        window.popBox = _this;
        return _this;
    }
    MyComponent.prototype.ok = function () {
        this.hide();
        this.modalResult = true;
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(HideEventName, false, false, true);
        //evt=new CustomEvent(HideEventName, { detail: true })
        this.container.dispatchEvent(evt);
    };
    MyComponent.prototype.cancel = function () {
        this.hide();
        this.modalResult = false;
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(HideEventName, false, false, false);
        //evt=new CustomEvent(HideEventName, { detail: false })
        this.container.dispatchEvent(evt);
    };
    MyComponent.prototype.init = function () {
        this.backdropElement = this.container.querySelector(".backdrop");
        ko.applyBindings(this, this.container);
    };
    MyComponent.prototype.show = function (message, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.options.title(options.title == undefined ? defaultModalOptions.title : options.title);
        this.options.isConfirmModal(options.isConfirmModal == undefined ? defaultModalOptions.isConfirmModal : options.isConfirmModal);
        this.options.backdrop(options.backdrop == undefined ? defaultModalOptions.backdrop : options.backdrop);
        this.options.showHeader(options.showHeader == undefined ? defaultModalOptions.showHeader : options.showHeader);
        this.options.showFooter(options.showFooter == undefined ? defaultModalOptions.showFooter : options.showFooter);
        this.options.isActionSheet(options.isActionSheet == undefined ? defaultModalOptions.isActionSheet : options.isActionSheet);
        requestAnimationFrame(function () {
            return options.isActionSheet ?
                _this.container.classList.add("modalContainer--action-sheet") :
                _this.container.classList.remove("modalContainer--action-sheet");
        });
        if (message instanceof Element) {
            this.message("");
            this.elementParent = message.parentElement;
            // this.container.querySelector(".modal-body").innerHTML = "";
            this.container.querySelector(".modal-body").appendChild(message);
        }
        else
            this.message(message);
        this.modalResult = options.isConfirmModal ? false : true; //reset to default result
        requestAnimationFrame(function () { return _this.container.classList.add("show"); });
        return new Promise(function (o, c) {
            var handler = function (e) {
                e.stopPropagation();
                e.preventDefault();
                e.detail ? o() : c();
                if (message instanceof Element) {
                    _this.elementParent.appendChild(message);
                }
                _this.container.removeEventListener(HideEventName, handler, true);
            };
            _this.container.addEventListener(HideEventName, handler, true);
        });
    };
    MyComponent.prototype.hide = function () {
        this.container.classList.remove("show");
    };
    return MyComponent;
}(Component));
export default new MyComponent();
